export enum ImportJobStatusType {
  Processed = 'Processed',
  Closed = 'Closed',
  Processing = 'Processing',
  ErrorProcessing = 'Error Processing',
  Reprocessing = 'Reprocessing'
}